import {IComponentOptions, IFilterService} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../authentication/service/AuthServiceRS.rest';
import {TSRefreshEvent} from '../../core/events/TSRefreshEvent';
import {DownloadRS} from '../../core/service/downloadRS.rest';
import RoleUtilService from '../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../core/service/SchadenfallModelManager';
import SchadenfallRS from '../../core/service/schadenfallRS.rest';
import {TSBemerkungScope} from '../../models/enums/TSBemerkungScope';
import {TSDocumentType} from '../../models/enums/TSDokumentType';
import {TSSchadenfallEvent} from '../../models/enums/TSSchadenfallEvent';
import {getTSSchadenfallStatusalues, getTSSchadenfallStatusOffen} from '../../models/enums/TSSchadenfallStatus';
import TSBenutzer from '../../models/TSBenutzer';
import TSSchadenfaelleSearchresultDTO from '../../models/TSSchadenfaelleSearchresultDTO';
import TSSchadenfallDTO from '../../models/TSSchadenfallDTO';
import TSSchadenfallPreFilterDTO from '../../models/TSSchadenfallPreFilterDTO';
import TSUser from '../../models/TSUser';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;
import IScope = angular.IScope;

declare let require: any;
let template = require('./schadenfaelleListView.html');

export class SchadenfaelleListViewComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = SchadenfaelleListViewController;
    controllerAs = 'vm';
    bindToController = true;
    bindings: any = {
        verantwortliche: '<',
    };

}

export class SchadenfaelleListViewController {

    private schadenfaelleList: Array<TSSchadenfallDTO>;
    totalResultCount: string = '-';
    tabs: any[] = [];
    selectedPrefilter: TSSchadenfallPreFilterDTO;
    selectedTab: number;
    verantwortliche: Array<TSBenutzer>;
    currentPrincipal: TSUser | undefined;
    currentUsername: string | undefined;
    emptyFilter: TSSchadenfallPreFilterDTO;

    static $inject: string[] = ['$filter', '$state', '$log', 'CONSTANTS', '$q', 'SchadenfallRS', '$scope', 'AuthServiceRS', 'RoleUtilService', 'DownloadRS', 'SchadenfallModelManager'];

    constructor(private $filter: IFilterService,
                private $state: IStateService, private $log: ILogService, private CONSTANTS: any,
                private $q: IQService, private schadenfallRS: SchadenfallRS, private $scope: IScope, private authService: AuthServiceRS,
                private roleUtilService: RoleUtilService,
                private downloadRS: DownloadRS,
                private schadenfallModelManager: SchadenfallModelManager,
    ) {

    }

    $onInit() {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;
        this.emptyFilter = new TSSchadenfallPreFilterDTO(false, undefined, false, undefined);
        this.initViewModel();
    }

    private initViewModel() {

        this.tabs.push({
            title: 'OFFENE',
            prefilter: new TSSchadenfallPreFilterDTO(false, undefined, true, getTSSchadenfallStatusOffen()),
            showVerantwortlicherFilter: true,
            changeVerantwortlicherEnabled: true,
        });
        if (this.authService.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
            this.tabs.push({
                title: 'NICHT_ZUGETEILT',
                prefilter: new TSSchadenfallPreFilterDTO(true, undefined, true, getTSSchadenfallStatusOffen()),
                showVerantwortlicherFilter: true,
                changeVerantwortlicherEnabled: true,
            });
            this.tabs.push({
                title: 'MEINE_SCHADENFAELLE',
                prefilter: new TSSchadenfallPreFilterDTO(true, this.currentUsername, true, getTSSchadenfallStatusOffen()),
                showVerantwortlicherFilter: false,
                changeVerantwortlicherEnabled: true,
            });
        }
        this.tabs.push({
            title: 'ALLE_TITLE',
            prefilter: new TSSchadenfallPreFilterDTO(false, undefined, true, getTSSchadenfallStatusalues()),
            showVerantwortlicherFilter: true,
            changeVerantwortlicherEnabled: false,
        });

        this.selectedPrefilter = this.tabs[0].prefilter;

    }

    private createTabsForUsers() {
        for (let verantwortlicher of this.verantwortliche) {
            // aktueller benutzer kommt nicht in den tabs
            if (verantwortlicher.email !== this.currentUsername) {
                this.tabs.push({
                    title: verantwortlicher.getFullName(),
                    prefilter: new TSSchadenfallPreFilterDTO(true, verantwortlicher.email, false, undefined),
                    showVerantwortlicherFilter: true,
                    changeVerantwortlicherEnabled: true,
                })
            }
        }
    }

    public passFilterToServer = (tableFilterState: any, prefilter: TSSchadenfallPreFilterDTO): IPromise<TSSchadenfaelleSearchresultDTO> => {
        this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
        return this.schadenfallRS.searchSchadenfaelle(tableFilterState, prefilter).then((response: TSSchadenfaelleSearchresultDTO) => {
            this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
            this.schadenfaelleList = response.schadenfallDTOs;
            return response;
        });

    };

    public getSchadenfaelleList(): Array<TSSchadenfallDTO> {
        return this.schadenfaelleList;
    }

    public editFall(schadenfall: TSSchadenfallDTO, event: any): void {
        if (schadenfall) {
            let isCtrlKeyPressed: boolean = (event && event.ctrlKey);
            this.openFall(schadenfall.schadenfallId, 'gesucherstellen', isCtrlKeyPressed);
        }
    }

    public updateVerantwortlicher(schadenfallId: string, verantwortlicher: string) {
        this.schadenfallRS.updateVerantwortlicher(schadenfallId, verantwortlicher);

    }

    private selectTab(selected: any) {
        this.selectedPrefilter = this.tabs[selected].prefilter;
        this.selectedTab = selected;
        // trigger refresh of smartTable
        this.$scope.$broadcast(TSRefreshEvent[TSRefreshEvent.REFRESH_ST_TABLE]);
    }

    private openFall(schadenfallId: string, urlToGoTo: string, isCtrlKeyPressed: boolean): void {
        if (schadenfallId) {
            if (isCtrlKeyPressed) {
                let url = this.$state.href(urlToGoTo, {createNew: false, schadenfallId: schadenfallId});
                window.open(url, '_blank');
            } else {
                this.$state.go(urlToGoTo, {createNew: false, schadenfallId: schadenfallId});
            }
        }
    }

    public downloadDeckblatt(schadenfall: any, event: any): void {
        this.schadenfallRS.generateDeckblatt(schadenfall.schadenfallId).then(result => {
            console.log(result);
            this.downloadRS.getAccessTokenDocument(schadenfall.schadenfallId, TSDocumentType.TMP_DECKBLATT, result.id).then(result => {
                let win: Window = this.downloadRS.prepareDownloadWindow();
                this.downloadRS.startDownload(result.accessToken, result.filename, false, win);
            });
        });
    }

    public deleteSchadenfall(schadenfallId: string, event: any): void {
        this.schadenfallModelManager.handleTransitionForId(schadenfallId, TSBemerkungScope.SCHADENFALL, undefined, '', TSSchadenfallEvent.LOESCHEN)
            .then((response: any) => {
                this.$state.reload();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/schadenfaelle/component/schadenfaelleListView.ts